// src/i18n.ts — Configuration i18next pour SAGeCOM
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frTranslation from './locales/fr/translation.json';
import enTranslation from './locales/en/translation.json';

const resources = {
  fr: { translation: frTranslation },
  en: { translation: enTranslation },
};

i18n
  .use(LanguageDetector)          // Détecte la langue du navigateur
  .use(initReactI18next)          // Passe i18n à React
  .init({
    resources,
    fallbackLng: 'fr',            // Langue par défaut : Français
    supportedLngs: ['fr', 'en'],

    detection: {
      // Ordre de détection : localStorage d'abord, puis navigateur
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'sagecom_lang',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,          // React échappe déjà les valeurs
    },

    react: {
      useSuspense: false,          // Évite les suspense non nécessaires
    },
  });

export default i18n;
